
import sha256 from 'crypto-js/sha256';
import { postApi, setToken } from './api';

let user = null;

export function setUser(Name, Role) { user = Object.freeze({ Name, Role}); }
export function logout()
{
  user = null;
  window.localStorage.removeItem('security-token');
  window.location.reload();
}

class Authentication
{
  constructor() { this.logout = logout; }

  login(username, password)
  {
    password = sha256(password).toString();
    return postApi('login', {username, password}).then( resp => {
      if (resp.success)
      {
        setToken(resp.token);
        setUser(resp.name, resp.role);
      }
      return resp;
    });
  }

  get User() { return user; }

}

const helper = new Authentication();
export default helper;
